import { Component, EventEmitter, Input, Output } from "@angular/core";
import { animate, style, transition, trigger } from "@angular/animations";
import { Validateable } from "@models/interfaces";
import { TranslationService } from "@core-services/translation.service";
import { InfoService } from "@core-services/info.service";
import { config, externalPaths } from "@config";

@Component({
	selector: "verification-terms-modal",
	templateUrl: "./verification-terms-modal.component.html",
	styleUrls: ["./verification-terms-modal.component.scss"],
	animations: [
		trigger("readMoreAnimation", [
			transition(":enter", [style({ opacity: 0 }), animate("1s ease-out", style({ opacity: 1 }))])
		])
	],
	standalone: false
})
export class VerificationTermsModalComponent {
	@Input() public logoUrl: string = "";
	@Input() public isSolarisVerification?: boolean = false;
	@Input() public moreBiometricKey: string = "eid_data_biometric_content_2";
	@Output() public onAccept: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() public eidTermsAccepted: EventEmitter<boolean> = new EventEmitter<boolean>();

	private verificationTerms: EidVerificationTerms = new EidVerificationTerms();

	public constructor(
		private translationService: TranslationService,
		private infoService: InfoService
	) {}

	private setTermsAccepted(value: boolean): void {
		this.eidTermsAccepted.emit(value);
	}

	public getVerificationTerms(): EidVerificationTerms {
		return this.verificationTerms;
	}

	public isTermsButtonDisabled(): boolean {
		if (this.isSolarisVerification) {
			return false;
		}
		return !this.verificationTerms.allTermsChecked();
	}

	public onContinueClick(): void {
		if (!this.verificationTerms.allTermsChecked() && !this.isSolarisVerification) {
			this.verificationTerms.getUncheckedTerms().forEach((term) => {
				this.verificationTerms.wiggle(term.getName());
			});
			this.infoService.setError(this.translationService.translate("info_text_offer_checkboxes_not_checked"));
			return;
		}

		this.onAccept.emit();
		this.setTermsAccepted(true);
	}

	public getReminderNumbers(): string[] {
		return ["1", "2", "3"]; // Orange box
	}

	public getSupportLink(): string {
		return config.baseUrl + TranslationService.getLanguageIsoCode() + config.externalPaths["privacyPolicy"]["link"];
	}

	public getSolarisSupportLink(): string {
		return this.translationService.getHdLink() + externalPaths["solaris"]["hdLink"];
	}
}

class EidVerificationTerms extends Validateable {
	public term2: boolean = false;

	public terms: SliderTerm[] = [
		new SliderTerm(
			"term2",
			"eid_data_term_2_title",
			"pre_verification_document_data_processing_description1_uk",
			"eid_hyperlink"
		)
	];

	public allTermsChecked(): boolean {
		return this.terms.every((term) => this[term.getName()]);
	}

	public getUncheckedTerms(): SliderTerm[] {
		return this.terms.filter((term) => !this[term.getName()]);
	}
}

class SliderTerm {
	private name: string = "";
	private title_key: string = "";
	private info_key: string = "";
	private link?: string = "";

	public constructor(name: string, title: string, info: string, link: string) {
		this.name = name;
		this.title_key = title;
		this.info_key = info;
		this.link = link;
	}

	public getName(): string {
		return this.name;
	}

	public getTitleKey(): string {
		return this.title_key;
	}

	public getInfoKey(): string {
		return this.info_key;
	}

	public getLink(): string {
		return this.link;
	}
}
